export const IS_PASSWORD_VALID = 'isPasswordValid';

export type ServicePasswordStrengthQueries = {
    [IS_PASSWORD_VALID]: undefined;
};

export type ServicePasswordStrengthQueriesResponseType = {
    [IS_PASSWORD_VALID]: boolean;
};
